module.exports = __webpack_public_path__ + "img/b135ff2f5c1c3f9e8a8b364e38870470.b135ff2f.png";